import { AxiosError } from "axios"

export const getErrorMessage = (e: unknown) => {
  const error = e as AxiosError
  if (error.isAxiosError) {
    if (error.response) {
      return error.response.data
    } else {
      return error.message
    }
  } else {
    return error.message
  }
}

export const createError = (message: unknown): void => {
  const element = document.createElement("div")
  element.classList.add("error")
  element.innerHTML = `<div>${message}</div><button class="btn" onclick="window.removeError(event)"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6l-12 12" /><path d="M6 6l12 12" /></svg></button>`
  document.body.appendChild(element)
}
